export default __webpack_public_path__ + "static/media/Huquq-top-img.0a0c8b1c.jpg";